// import React, { useEffect, useState } from "react";

// interface CountdownTimerProps {
//   createdOn?: string;
//   dueOn?: string;
//   status?: string;
// }

// export const CountdownTimer: React.FC<CountdownTimerProps> = React.memo(
//   ({ createdOn, dueOn, status }) => {

//     const [remaining, setRemaining] = useState<number | null>(null);

//     const isAcceptancePending =
//       status === "To be Accepted" ||
//       status === "Acceptance Overdue" ||
//       status === "Awaiting Response" ||
//       status === "Waiting for acceptance";

//     const isExpectedDelivery =
//       status === "Expected Delivery";

//     const shouldShowTimer =
//       isAcceptancePending || isExpectedDelivery;

//     useEffect(() => {

//       if (!shouldShowTimer) {
//         setRemaining(null);
//         return;
//       }

//       let targetTime: number | null = null;
//       if (isExpectedDelivery && dueOn) {

//         const normalizedDate = dueOn.replace(" ", "T");

//         const due = new Date(normalizedDate).getTime();

//         if (!isNaN(due)) {
//           targetTime = due;
//         }
//       }

//       // =====================================================
//       // EXISTING ACCEPTANCE TIMER
//       // =====================================================

//       if (!targetTime && isAcceptancePending) {

//         if (dueOn) {

//           const normalizedDate = dueOn.replace(" ", "T");

//           const due = new Date(normalizedDate).getTime();

//           if (!isNaN(due)) {
//             targetTime = due;
//           }
//         }

//         if (!targetTime && createdOn) {

//           const normalizedCreatedOn =
//             createdOn.replace(" ", "T");

//           const created =
//             new Date(normalizedCreatedOn).getTime();

//           if (!isNaN(created)) {
//             targetTime = created;
//           }
//         }
//       }

//       // =====================================================
//       // NO TARGET TIME
//       // =====================================================

//       if (!targetTime) {
//         setRemaining(null);
//         return;
//       }

//       // =====================================================
//       // UPDATE TIMER
//       // =====================================================

//       const update = () => {

//         const now = Date.now();

//         const left = targetTime! - now;

//         setRemaining(left > 0 ? left : 0);
//       };

//       update();

//       const interval = setInterval(update, 1000);

//       return () => clearInterval(interval);

//     }, [
//       createdOn,
//       dueOn,
//       shouldShowTimer,
//       isExpectedDelivery,
//       isAcceptancePending
//     ]);

//     // =====================================================
//     // HIDE TIMER
//     // =====================================================

//     if (!shouldShowTimer || remaining === null) {
//       return <span className="text-muted"></span>;
//     }

//     // =====================================================
//     // FORMAT TIME
//     // =====================================================

//     const totalSeconds =
//       Math.floor(remaining / 1000);

//     const hours =
//       Math.floor(totalSeconds / 3600);

//     const minutes =
//       Math.floor((totalSeconds % 3600) / 60);

//     const seconds =
//       totalSeconds % 60;

//     return (
//       <span className="text-danger fw-semibold">
//         {String(hours).padStart(2, "0")}:
//         {String(minutes).padStart(2, "0")}:
//         {String(seconds).padStart(2, "0")}
//       </span>
//     );
//   }
// );


import React, { useEffect, useState } from "react";

interface CountdownTimerProps {
  createdOn?: string;
  dueOn?: string;
  status?: string;
}

export const CountdownTimer: React.FC<CountdownTimerProps> = React.memo(
  ({ createdOn, dueOn, status }) => {
    const [remaining, setRemaining] = useState<number | null>(null);

    const isAcceptancePending =
      status === "To be Accepted" ||
      status === "Acceptance Overdue" ||
      status === "Awaiting Response" ||
      status === "Waiting for acceptance";

    const isExpectedDelivery =
      status === "Expected Delivery";

    const shouldShowTimer =
      isAcceptancePending || isExpectedDelivery;

    useEffect(() => {
      if (!shouldShowTimer) {
        setRemaining(null);
        return;
      }

      let targetTime: number | null = null;

      // =====================================================
      // EXPECTED DELIVERY TIMER
      // =====================================================

      if (isExpectedDelivery && dueOn) {
        const normalizedDate = dueOn.replace(" ", "T");
        const due = new Date(normalizedDate).getTime();

        if (!isNaN(due)) {
          targetTime = due;
        }
      }

      // =====================================================
      // ACCEPTANCE TIMER
      // =====================================================

      if (!targetTime && isAcceptancePending) {
        if (dueOn) {
          const normalizedDate = dueOn.replace(" ", "T");
          const due = new Date(normalizedDate).getTime();

          if (!isNaN(due)) {
            targetTime = due;
          }
        }

        if (!targetTime && createdOn) {
          const normalizedCreatedOn =
            createdOn.replace(" ", "T");

          const created =
            new Date(normalizedCreatedOn).getTime();

          if (!isNaN(created)) {
            targetTime = created;
          }
        }
      }

      // =====================================================
      // NO TARGET TIME
      // =====================================================

      if (!targetTime) {
        setRemaining(null);
        return;
      }

      // =====================================================
      // UPDATE TIMER
      // =====================================================

      const update = () => {
        const now = Date.now();

        // Can now be POSITIVE or NEGATIVE
        const left = targetTime! - now;

        setRemaining(left);
      };

      update();

      const interval = setInterval(update, 1000);

      return () => clearInterval(interval);
    }, [
      createdOn,
      dueOn,
      shouldShowTimer,
      isExpectedDelivery,
      isAcceptancePending,
    ]);

    // =====================================================
    // HIDE TIMER
    // =====================================================

    if (!shouldShowTimer || remaining === null) {
      return <span className="text-muted"></span>;
    }

    // =====================================================
    // FORMAT TIME
    // =====================================================

    const isNegative = remaining < 0;

    const totalSeconds =
      Math.floor(Math.abs(remaining) / 1000);

    const hours =
      Math.floor(totalSeconds / 3600);

    const minutes =
      Math.floor((totalSeconds % 3600) / 60);

    const seconds =
      totalSeconds % 60;

    const formattedTime = `${String(hours).padStart(2, "0")}:${String(
      minutes
    ).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;

    return (
      <span className="text-danger fw-semibold">
        {isNegative ? "-" : ""}
        {formattedTime}
      </span>
    );
  }
);

